/**
 * Shared hotspot stimulus for every Hotspot bank item.
 *
 * Authors mark one correct zone on the same clinical figure. Preview and
 * review therefore render one image and one correct-area rectangle rather than
 * inventing a different diagram per row.
 */

/** Percentages of the image box (`left` / `top` / `width` / `height`). */
export interface HotspotAreaPct {
  left: number
  top: number
  width: number
  height: number
}

export const HOTSPOT_STOCK = {
  /**
   * Legacy public path — kept for tests / older payloads. Prefer rendering
   * `HotspotStockFigure` (inlined) so SPA hosts cannot rewrite the asset to HTML.
   */
  src: "/hotspot/clinical-figure.svg",
  alt: "Anterior chest figure with heart silhouette",
  imageLabel: "Anterior chest figure",
  /**
   * Apex of the heart on the shared figure. Same box for every hotspot item;
   * region labels still vary by topic so the list under the figure stays useful.
   */
  correctArea: {
    left: 34,
    top: 48,
    width: 16,
    height: 22,
  } satisfies HotspotAreaPct,
} as const
